module.exports = __webpack_public_path__ + "img/Carousel-Beneficios-icono-01.10145338.svg";